import localStorageHelper from '@/helpers/global/localStorage.helper';

const FIRST_VISIT_KEY = 'first_visit_data';

const TRACKING_PARAMS = ['medium', 'campaign', 'adgroup', 'source', 'term', 'content'];

class FirstVisitHelper {
  private getSourceData(): Record<string, string> {
    const result: Record<string, string> = {};
    if (document.referrer) {
      result.referrer = document.referrer;
    }
    result.landing_page = window.location.href;
    return result;
  }

  private decodeQueryString(queryString: string): string {
    if (!queryString) return queryString;
    return queryString
      .replace(/%26amp%3B/gi, '&')
      .replace(/%26amp/gi, '&')
      .replace(/&amp;/g, '&')
      .replace(/&amp/g, '&');
  }

  private hasUtmParams(searchString: string): boolean {
    try {
      const params = new URLSearchParams(searchString);
      return Array.from(params.keys()).some((key) => {
        const lower = key.toLowerCase();
        return lower.startsWith('utm_') || TRACKING_PARAMS.includes(lower);
      });
    } catch {
      return /[?&](utm_|medium|campaign|adgroup|source|term|content)=/i.test(searchString);
    }
  }

  init(): void {
    const stored = localStorageHelper.getItem(FIRST_VISIT_KEY);
    const searchString = this.decodeQueryString(window.location.search);
    const hasUtm = this.hasUtmParams(searchString);

    if (!stored || hasUtm) {
      localStorageHelper.setItem(FIRST_VISIT_KEY, JSON.stringify(this.getSourceData()));
    }
  }
}

export default new FirstVisitHelper();